// @React
import React, { useEffect, useState } from "react"
// Hooks and Redux
import { useAppSelector } from "../../../redux/hooks"
import {
  Box,
  Icon,
  CircularProgress,
  Container,
  ThemeProvider,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
  Checkbox,
  FormControl,
  Paper,
  TextField,
  InputAdornment,
  List,
  IconButton,
  Divider,
  Pagination,
  Drawer,
  Grid,
  Tooltip,
  Autocomplete,
  Link,
  Chip,
  Breadcrumbs,
} from "@mui/material"

// @MUI Components

import {
  GridCellParams,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  DataGrid,
  enUS,
} from "@mui/x-data-grid"
import { thTHGrid } from "../../../@types/DataGridLocaleText"

// @MUI Icons
import AssignmentTurnInIcon from "@mui/icons-material/AssignmentTurnedIn"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import InfoIcon from "@mui/icons-material/Info"
// import Paper from "@mui/material/Paper"
import theme from "../../../styles/theme"

import { useTranslation } from "react-i18next"
import dayjs, { Dayjs } from "dayjs"
import Swal from "sweetalert2"

// @Utils
import {
  Link as ReactRouterLink,
  useParams,
  useNavigate,
} from "react-router-dom"

// Services
import {
  fetchProvinces,
} from "../../users/AppFormPage/AddressInfo/fetchGeoData"
import {
  getAllDocuments,
  getDocumentsfile,
} from "../../../services/UserService"

import UploadFileDocs from "../submitted-form/UploadFileDocs"

//service
import {
  getExcelECDataById,
  uploadStatus,
} from "../../../services/ExcelECService"
import { getECDataById } from "../../../services/ECService"
import { getContractByUserId } from "../../../services/EmployeeContractService"
// import { getAllActiveCompany } from "../../../services/MasterDataService" //เปลี่ยนมาใช้ useAppSelector
// import { getAllStatus } from "../../../services/StatusService" //เปลี่ยนมาใช้ useAppSelector

import { validateMicrosoftFile } from "../../../utils"
import { numToThaiBaht } from "../../../utils/thaiBahtText"

// Types
import { CompanyInter } from "../../../@types/ECData.type"
import { Status } from "../../../@types"

import fontkit from "@pdf-lib/fontkit"
import { PDFDocument, PDFTextField, PDFName } from "pdf-lib"

interface Prefix {
  [key: string]: string
}

const PREFIX: Prefix = {
  Miss: "Miss",
  Mr: "Mr.",
  Mrs: "Mrs.",
}

interface CountryNationl {
  [key: string]: string
}

const NATIONALITY: CountryNationl = {
  KHM: "Cambodia",
  LAO: "Lao People's Democratic Republic",
  MMR: "Myanmar",
  THA: "Thailand",
}

interface MaritalStatus {
  [key: string]: string
}

const MARITAL_STATUS: MaritalStatus = {
  D: "Divorced",
  E: "Separated",
  M: "Married",
  S: "Single",
  W: "Widowed",
}

interface Gender {
  [key: string]: string
}

const GENDER: Gender = {
  M: "Male",
  F: "Female",
}

interface Religion {
  [key: string]: string
}

const RELIGION: Religion = {
  BDH: "Buddhism",
  CHR: "Christ",
  HND: "Hindu",
  ISL: "Islamic",
  NON: "None Specify",
  SIK: "Sikh",
}

const bodyStyle = {
  fontSize: { xs: 15, sm: 17 },
  letterSpacing: 0.3,
}

const ExcelEcDetail: React.FC<any> = () => {
  const { t, i18n } = useTranslation()
  const { id, type } = useParams()
  const navigate = useNavigate()
  const token = localStorage.getItem("access_token") || ""
  const { rolesite } = useAppSelector((state) => state.user)
  const { prefixes } = useAppSelector((state) => state.masterData)

  const [appFormData, setAppFromData] = useState<any | null>(null)
  const [loadingData, setLoadingData] = useState<boolean>(true)
  const [forwardPath, setForwardPath] = useState<string>("")
  const [prefixList, setPrefixList] = useState<any>([])
  const [contractList, setContractList] = useState<any | null>([])
  const [loadingUpload, setLoadingUpload] = useState<boolean>(true)
  const [uploadFilesStatus, setUploadFilesStatus] = useState<boolean>(false)
  // เปลี่ยนมาใช้ useAppSelector
  // const [statusData, setStatusData] = useState<Status[]>([])
  const { statuses: statusData, companies: companyList } = useAppSelector(
    (state) => state.masterData
  )
  const [statusForm, setStatusForm] = useState<any>({})
  const [provinceJSON, setProvinceJSON] = useState<any[]>([])

  const [address, setAddress] = useState({
    legal_address: {
      address_house_number: null,
      address_moo: null,
      address_lane: null,
      address_street: null,
      address_sub_district: null,
      address_district: null,
      address_province: null,
      address_postal_code: null,
    },
    mailing_address: {
      address_house_number: null,
      address_moo: null,
      address_lane: null,
      address_street: null,
      address_sub_district: null,
      address_district: null,
      address_province: null,
      address_postal_code: null,
    },
  })
  const [provincesTH, setProvincesTH] = useState<string[]>([])
  const [districtsTH, setDistrictsTH] = useState<string[]>([])
  const [subDistrictsTH, setSubDistrictsTH] = useState<string[]>([])
  const [provincesEN, setProvincesEN] = useState<string[]>([])
  const [districtsEN, setDistrictsEN] = useState<string[]>([])
  const [subDistrictsEN, setSubDistrictsEN] = useState<string[]>([])
  const [filesBaseData, setFilesBaseData] = useState<ifileBase[]>([])
  const [documentsRefs, setDocumentsRefs] = useState<[]>([])
  const [userId, setUserId] = useState<string>("")

  const [isLoadingCompanyList, setIsLoadingCompanyList] =
    useState<boolean>(false) // เปลี่ยนมาใช้ useAppSelector (ข้อมูลพร้อมใช้จาก store แล้ว)
  // เปลี่ยนมาใช้ useAppSelector
  // const [companyList, setCompanyList] = useState<any[]>([])

  const monthTH: string[] = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ]
  const monthEN: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]

  type ifileBase = {
    dataPath: string
    type: string
    name: string
  }

  useEffect(() => {
    const fetchProvincesData = async () => {
      try {
        const provincesData = await fetchProvinces()
        setProvinceJSON(provincesData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    fetchProvincesData()
  }, [navigate])

  const debugBase64 = (base64URL: string) => {
    let win = window.open()
    win?.document.write(
      '<iframe src="' +
        base64URL +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    )
  }

  const debugBase64New = (base64URL: string) => {
    try {
      const base64Data = base64URL.split(",")[1]
      const byteCharacters = atob(base64Data)
      const byteArray = new Uint8Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: "application/pdf" })
      const objectUrl = URL.createObjectURL(blob)
      window.open(objectUrl, "_blank")
    } catch (error) {
      console.error("Error opening PDF:", error)
    }
  }

  const mapNameCompany = (companyCode: string): string => {
    const company = companyList.find(
      (item: CompanyInter) => companyCode === item.company_code
    )
    return company
      ? `${company.company_code} - ${company.company_name}`
      : companyCode
  }

  // NOTE: calculateAge — ซ้ำกับ admin/PersonalInfo.tsx, EditJobDetailData.tsx, SignUp.tsx, JobAppDetail.tsx, UploadExcel.tsx, FileContract.tsx ควรย้ายไปรวมใน utils/index.ts
  const calculateAge = async (dateOfBirth: string) => {
    const [day, month, year] = dateOfBirth.split("/").map(Number)
    const birthDate = new Date(year, month - 1, day)
    const today = new Date()

    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }

    return age.toString()
  }

  const setPdfTextFields = (form: any, fieldValues: any, customFont: any) => {
    const fields = form.getFields()
    for (const field of fields) {
      const getName = field.getName()
      for (const fieldName in fieldValues) {
        try {
          if (fieldName === getName) {
            const value = fieldValues[fieldName]
            field.setText(value)
            field.setFontSize(13)
            field.updateAppearances(customFont)
          }
        } catch (error) {
          console.log(`Error setting field "${fieldName}":`, error)
        }
      }
    }
  }

  const findFieldPageNumber = async (
    arrayBuffer: string | ArrayBuffer,
    fieldName: string
  ): Promise<number> => {
    try {
      const pdfDoc = await PDFDocument.load(arrayBuffer)
      const form = pdfDoc.getForm()
      const fields = form.getFields()
      const pages = pdfDoc.getPages()

      let foundOnPage = 0
      const P = PDFName.of("P")
      for (const field of fields) {
        const name = field.getName()
        if (name.toLocaleLowerCase().includes(fieldName.toLocaleLowerCase())) {
          const widgets = field.acroField.getWidgets()
          for (const widget of widgets) {
            const widgetDict = widget.dict
            const pageRef = widgetDict.get ? widgetDict.get(P) : null
            foundOnPage = pageRef
              ? pages.findIndex((page) => page?.ref === pageRef)
              : 0
          }
        }
      }

      return foundOnPage
    } catch (error) {
      console.error(`Error processing PDF ${arrayBuffer}:`, error)
      throw error
    }
  }

  const arrayBufferToBase64DataUrl = async (
    arrayBuffer: ArrayBuffer,
    mimeType: string
  ) => {
    return new Promise((resolve, reject) => {
      const blob = new Blob([arrayBuffer], { type: mimeType })
      const reader = new FileReader()

      reader.onload = function (event) {
        resolve(event?.target?.result)
      }

      reader.onerror = function (error) {
        reject(error)
      }
      reader.readAsDataURL(blob)
    })
  }
  const handleFieldsToSet = async (
    fields: any,
    dataToField: any,
    activeContractDoc: any,
    signStatus: boolean
  ) => {
    const fieldsToSet: { [key: string]: any } = {}
    const hr = activeContractDoc?.emplist
      ? `${activeContractDoc?.emplist?.first_name_th} ${activeContractDoc?.emplist?.last_name_th}`
      : ""

    const employeeFullName =
      `${dataToField?.first_name_th} ${dataToField?.last_name_th}` || ""
    const employeeENFullName =
      `${dataToField?.first_name_en} ${dataToField?.last_name_en}` || ""

    if (!fields || !dataToField) {
      return fieldsToSet
    }

    for (const field of fields) {
      const fieldName = field.getName()
      if (
        fieldName.indexOf("company") === 0 ||
        fieldName.indexOf("company_") === 0
      ) {
        const mapComp = mapNameCompany(dataToField?.company)
        fieldsToSet[fieldName] = `${mapComp.split("-")[1]}` || ""
      } else if (
        fieldName.indexOf("contact_date") === 0 ||
        fieldName.indexOf("contact_date_") === 0
      ) {
        fieldsToSet[fieldName] = (await hireDate(dataToField?.hire_date)) || ""
      } else if (
        (fieldName.indexOf("employee_old") === 0 ||
          fieldName.indexOf("employee_old_") === 0) &&
        dataToField?.date_of_birth
      ) {
        const old = await calculateAge(dataToField?.date_of_birth)
        fieldsToSet[fieldName] = old || ""
      } else if (
        fieldName.indexOf("employee_phone") === 0 ||
        fieldName.indexOf("employee_phone_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.phone_number || ""
      } else if (
        fieldName.indexOf("employee_name_") === 0 ||
        fieldName.indexOf("employee_name_") === 0
      ) {
        fieldsToSet[fieldName] = employeeFullName || ""
      } else if (fieldName.indexOf("employee_en_name_") === 0) {
        fieldsToSet[fieldName] = employeeENFullName || ""
      } else if (
        hr &&
        (fieldName.indexOf("hr_name") === 0 ||
          fieldName.indexOf("hr_name_") === 0)
      ) {
        fieldsToSet[fieldName] = hr || ""
      } else if (
        fieldName.indexOf("nationID") === 0 ||
        fieldName.indexOf("nationID_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.national_id || ""
      } else if (
        fieldName.indexOf("hire_date") === 0 ||
        fieldName.indexOf("hire_date_") === 0
      ) {
        fieldsToSet[fieldName] = (await hireDate(dataToField?.hire_date)) || ""
      }
      // work
      else if (
        fieldName.indexOf("employee_position") === 0 ||
        fieldName.indexOf("employee_positione_") === 0
      ) {
        fieldsToSet[fieldName] = activeContractDoc?.positionName
          ? activeContractDoc?.positionName
          : activeContractDoc?.ecData?.positionName
          ? activeContractDoc?.ecData?.positionName
          : ""
      }
      // house
      else if (
        fieldName.indexOf("employee_house_number") === 0 ||
        fieldName.indexOf("employee_house_number_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_house_number || ""
      } else if (
        fieldName.indexOf("employee_soi") === 0 ||
        fieldName.indexOf("employee_soi_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_lane || ""
      } else if (
        fieldName.indexOf("employee_road") === 0 ||
        fieldName.indexOf("employee_road_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_street || ""
      } else if (
        fieldName.indexOf("employee_moo") === 0 ||
        fieldName.indexOf("employee_moo_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_moo || ""
      } else if (
        fieldName.indexOf("employee_sub_district") === 0 ||
        fieldName.indexOf("employee_sub_district_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_sub_district || ""
      } else if (
        fieldName.indexOf("employee_district") === 0 ||
        fieldName.indexOf("employee_district_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_district || ""
      } else if (
        fieldName.indexOf("employee_province") === 0 ||
        fieldName.indexOf("employee_province_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_province || ""
      } else if (
        fieldName.indexOf("employee_postal_code") === 0 ||
        fieldName.indexOf("employee_postal_code_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_postal_code || ""
      } else if (
        fieldName.indexOf("employee_build") === 0 ||
        fieldName.indexOf("employee_build_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_building || ""
      } else if (
        fieldName.indexOf("employee_floor") === 0 ||
        fieldName.indexOf("employee_floor_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_floor || ""
      } else if (
        fieldName.indexOf("employee_room") === 0 ||
        fieldName.indexOf("employee_room_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.legal_room || ""
      }
      //salary
      else if (
        fieldName.indexOf("employee_101") === 0 ||
        fieldName.indexOf("employee_101_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.amount_101?.toString() || ""
      } else if (
        fieldName.indexOf("employee_102") === 0 ||
        fieldName.indexOf("employee_102_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.amount_102?.toString() || ""
      } else if (
        fieldName.indexOf("employee_thaitext") === 0 ||
        fieldName.indexOf("employee_thaitext_") === 0
      ) {
        fieldsToSet[fieldName] = dataToField?.amount_101
          ? numToThaiBaht(dataToField?.amount_101)
          : dataToField?.amount_102
          ? numToThaiBaht(dataToField?.amount_102)
          : ""
      } else if (signStatus) {
        const sign_date = dayjs(new Date()).format("DD/MM/BBBB")
        //  fieldsToSet.signed_date =
        //    `Digitally signed by: ${dataToField?.first_name_th} ${dataToField?.last_name_th} ${sign_date}` ||
        //    ""
        if (
          fieldName.indexOf("signed_date_") === 0 ||
          fieldName.indexOf("signed_date") === 0
        ) {
          fieldsToSet[fieldName] =
            `Digitally signed by: ${dataToField?.first_name_th} ${dataToField?.last_name_th} ${sign_date}` ||
            ""
        }
      } else {
        fieldsToSet[fieldName] = ""
      }
    }

    return fieldsToSet
  }

  const hireDate = async (date: string) => {
    const [day, month, year] = date.split("/").map(Number)

    return `${day}/${month}/${year + 543}`
  }

  const setInfroPDF = async (contract: any, base64Data: any, data: any) => {
    try {
      let convertedPdfDataUrl: any
      let arrayBuffer: string | ArrayBuffer
      const base64Split = base64Data?.split(",")[1]
      const base64PdfString = base64Split as string
      const bytes = Uint8Array.from(atob(base64PdfString), (c) =>
        c.charCodeAt(0)
      )
      arrayBuffer = bytes.buffer
      const pdfDoc = await PDFDocument.load(arrayBuffer)
      pdfDoc.registerFontkit(fontkit)
      const fontBytes = await fetch(
        "../../../../assets/fonts/TH_Sarabun.ttf"
      ).then((res) => res.arrayBuffer())
      const thaiFont = await pdfDoc.embedFont(fontBytes)
      const form = pdfDoc.getForm()
      const pages = pdfDoc.getPages()
      const fields = form.getFields()
      const initialValues: { [key: string]: any } = {}
      const extractedFieldNames: string[] = []

      for (const field of fields) {
        const fieldName = field.getName()
        extractedFieldNames.push(fieldName)

        if (field instanceof PDFTextField) {
          initialValues[fieldName] = field.getText()
        }

        if (
          fieldName.indexOf("hr_signed_image_") === 0 ||
          fieldName.indexOf("hr_signed_image") === 0
        ) {
          const pageSigned = await findFieldPageNumber(arrayBuffer, fieldName)
          const targetField = form.getTextField(fieldName)
          if (targetField) {
            const widgets = targetField.acroField.getWidgets()
            if (widgets.length > 0) {
              const firstWidget = widgets[0]
              const { x, y, width, height } = firstWidget.getRectangle()

              if (contract && contract?.empSigned) {
                const base64Data = await getDocumentsfile(
                  contract?.emplist?.dmsFileId,
                  "documentsEmp"
                )
                if (base64Data.status === 200) {
                  const base64Image = base64Data?.data.split(",")[1]
                  let signatureImage: any

                  if (contract?.emplist?.nameFile?.split(".")[1] === "png") {
                    signatureImage = await pdfDoc.embedPng(base64Image)
                  } else {
                    signatureImage = await pdfDoc.embedJpg(base64Image)
                  }

                  const firstPage = pages[pageSigned]
                  const imageDims = signatureImage.scaleToFit(width, height)
                  const xPos = x + (width - imageDims.width) / 2
                  const yPos = y + (height - imageDims.height) / 2

                  firstPage.drawImage(signatureImage, {
                    x: xPos,
                    y: yPos,
                    width: imageDims.width,
                    height: imageDims.height,
                  })

                  if (targetField) {
                    targetField.setText("")
                  }
                }
              }
            }
          }
        }
      }

      const dataSet = await handleFieldsToSet(
        fields,
        data,
        contract,
        contract.is_signed_active
      )

      setPdfTextFields(form, dataSet, thaiFont)

      const modifiedPdfBytes = await pdfDoc.save()
      const modifiedArrayBuffer = modifiedPdfBytes.buffer as ArrayBuffer
      convertedPdfDataUrl = await arrayBufferToBase64DataUrl(
        modifiedArrayBuffer,
        "application/pdf"
      )

      return convertedPdfDataUrl
    } catch (error) {
      console.error("Error processing PDF:", error)

      return false
    }
  }

  // เปลี่ยนมาใช้ useAppSelector
  // useEffect(() => {
  //   const fetchAllActiveCompany = async () => {
  //     try {
  //       const response = await getAllActiveCompany(true)
  //       if (response.data?.success) {
  //         setCompanyList(response?.data?.companies)
  //       }
  //     } catch (error) {
  //       console.error("Error fetching active companies:", error)
  //     } finally {
  //       setIsLoadingCompanyList(false)
  //     }
  //   }
  //   const fetchStatus = async () => {
  //     const response = await getAllStatus()

  //     if (response.data?.success) {
  //       setStatusData(response.data?.status)
  //     }
  //   }

  //   fetchStatus()
  //   fetchAllActiveCompany()
  // }, [])

  useEffect(() => {
    if (isLoadingCompanyList || companyList.length === 0) {
      return
    }

    const fetchECData = async () => {
      try {
        let base64DataPDF: any
        let base64Data: any
        const provinceData = provinceJSON
        const response =
          type === "excels-ec"
            ? await getExcelECDataById(id)
            : await getECDataById(id)
        const ECData =
          response.data?.success && response?.data?.ECData
            ? response?.data?.ECData
            : []
        const user_id =
          type === "data-ec" ? ECData?.AppFormStatus?.user_id : ECData?.user_id
        const statusFormName =
          type === "excels-ec"
            ? statusData.find((item) => item.id === ECData?.status_id)
            : {}
        setStatusForm(statusFormName)
        if (response?.data?.success) {
          const legalProvince = provinceData?.find(
            (province: any) =>
              province?.external_code === parseInt(ECData?.legal_province)
          )
          const mailingProvince = provinceData?.find(
            (province: any) =>
              province?.external_code === parseInt(ECData?.mailing_province)
          )
          ECData.legal_province = legalProvince
            ? localStorage.language === "th"
              ? legalProvince.label_th
              : localStorage.language === "en"
              ? legalProvince.label_en
              : ECData?.legal_province
            : ECData?.legal_province
          ECData.mailing_province = mailingProvince
            ? localStorage.language === "th"
              ? mailingProvince.label_th
              : localStorage.language === "en"
              ? mailingProvince.label_en
              : ECData?.legal_province
            : ECData?.legal_province
          setAppFromData(ECData)
          const respContract = await getContractByUserId(user_id)
          if (
            respContract.data?.success &&
            respContract?.data?.data?.length > 0
          ) {
            const contractData = respContract?.data?.data
              ? respContract.data.data
              : []
            const newDocuments = []
            for (let item in contractData) {
              if (!contractData[item].is_signed_active) {
                if (
                  contractData[item]?.ecData?.site_id &&
                  rolesite.indexOf(contractData[0]?.ecData?.site_id) > -1
                ) {
                  base64Data = await getDocumentsfile(
                    contractData[item].dmsFileId,
                    "contract"
                  )
                  base64DataPDF = await setInfroPDF(
                    contractData[item],
                    base64Data?.data,
                    ECData
                  )
                }
              } else {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const contractSigned = await getDocumentsfile(
                  contractData[item]?.dmsFileId,
                  "contractSigned"
                )
                base64DataPDF =
                  contractSigned.status === 200
                    ? (contractSigned.data as string)
                    : ""
              }
              if (base64DataPDF) {
                newDocuments.push({
                  id: contractData[item].id,
                  dmsFileId: contractData[item].dmsFileId,
                  is_active: contractData[item].is_active,
                  is_signed_active: contractData[item].is_signed_active,
                  name: contractData[item].name,
                  nameFile: contractData[item].nameFile,
                  type: contractData[item].type,
                  created_date: contractData[item].created_date,
                  created_by: contractData[item].created_by,
                  employmentContract: contractData[item]?.EmploymentContract,
                  employer: `${contractData[item]?.emplist?.first_name_th}  ${contractData[item]?.emplist?.last_name_th}`,
                  file: {
                    dataPath: base64DataPDF || "",
                    name: contractData[item]?.EmploymentContract?.name,
                    type: contractData[item]?.EmploymentContract?.type,
                  },
                })
              }
            }
            setContractList(newDocuments)
            newDocuments.length > 0
              ? setLoadingUpload(false)
              : setLoadingUpload(true)
          } else {
            setLoadingUpload(false)
          }
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingData(false)
      }
    }

    fetchECData()
  }, [navigate, id, type, companyList, isLoadingCompanyList, rolesite])

  useEffect(() => {
    const getDocumentsRef = async () => {
      try {
        const userID =
          appFormData?.AppFormStatus?.user_id.length > 0
            ? appFormData?.AppFormStatus?.user_id
            : appFormData?.user_id.length > 0
            ? appFormData?.user_id
            : ""

        if (appFormData && userID) {
          const newDocuments = []
          setUserId(userID)
          const response = await getAllDocuments(userID, "")

          if (response.data?.success) {
            const dataDocuments = response?.data?.document

            setDocumentsRefs(dataDocuments)
            for (let item in dataDocuments) {
              const base64Data = await getDocumentsfile(
                dataDocuments[item].dmsFileId,
                "documents"
              )
              if (base64Data.status === 200) {
                newDocuments.push({
                  dataPath: base64Data?.data,
                  name: dataDocuments[item].name,
                  type: dataDocuments[item].type,
                })
              }
            }
            setFilesBaseData(newDocuments)
          }
        }
        return true
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    getDocumentsRef()
  }, [navigate, appFormData])

  const formatDate = (value: number): string => {
    let date_of_format: string = ""
    const dateOfBirthString = appFormData?.date_of_birth ?? ""
    if (value === 1) {
      const newDate: string = dayjs(appFormData?.created_date)
        .toISOString()
        .split("T")[0]
      const date_token: string[] = newDate.split("-")
      let year: string = ""
      i18n.language === "th"
        ? (year = (parseInt(date_token[0]) + 543).toString())
        : (year = date_token[0] + ",")
      const date_of_send: string =
        date_token[2] + "/" + date_token[1] + "/" + year
      date_of_format = date_of_send
    } else if (value === 2 && dateOfBirthString) {
      const [dayApp, monthApp, yearApp] = dateOfBirthString
        .split("/")
        .map(Number)
      const dateBirth = `${monthApp}/${dayApp}/${yearApp}`
      const date: string = new Date(dateBirth!).getDate().toString()

      const month: number = new Date(dateBirth!).getMonth()
      const year: number = new Date(dateBirth!).getFullYear()
      let date_of_birth: string = ""
      i18n.language === "th"
        ? (date_of_birth = date + " " + monthTH[month] + " " + (year + 543))
        : (date_of_birth = date + " " + monthEN[month] + " " + year)
      date_of_format = date_of_birth
    } else if (value === 3) {
      const date: string = new Date(appFormData?.start_date!)
        .getDate()
        .toString()
      const month: number = new Date(appFormData?.start_date!).getMonth()
      const year: number = new Date(appFormData?.start_date!).getFullYear()
      let date_of_work: string = ""
      i18n.language === "th"
        ? (date_of_work = date + " " + monthTH[month] + " " + (year + 543))
        : (date_of_work = date + " " + monthEN[month] + " " + year)
      date_of_format = date_of_work
    }
    return date_of_format
  }

  const mapPrefix = (prefix: string, lang: string) => {
    const data: any =
      prefix && prefixList.find((item: any) => prefix === item.external_code)!
    const defaultPrefix =
      data && lang === "TH"
        ? data.label
        : prefix === "Mr" || prefix === "Miss" || prefix === "Mrs"
        ? `${PREFIX[prefix!]} `
        : ""

    return defaultPrefix
  }

  const columns: GridColDef[] = [
    {
      field: "is_active",
      headerName: `${t("Status")}`,
      headerAlign: "center",
      width: 120,
      hideSortIcons: true,
      disableColumnMenu: true,
      filterable: false,
      sortable: false,
      pinnable: true,
      renderCell: (params: GridCellParams) =>
        params.row.is_active === true ? (
          <Chip
            variant="outlined"
            color="success"
            label={t("Active")}
            size="small"
          />
        ) : (
          <Chip
            variant="outlined"
            color="warning"
            label={t("Inactive")}
            size="small"
          />
        ),
    },
    {
      field: "nameFile",
      headerName: `${t("text_nameFile")}`,
      width: 300,
      valueGetter: (params: GridCellParams) => params.row.nameFile,
      renderCell: (params: GridCellParams) => params.row.nameFile ?? "-",
    },
    {
      field: "is_signed_active",
      headerName: `${t("text_signed_status")}`,
      width: 200,
      valueGetter: (params: GridCellParams) => params.row.is_signed_active,
      renderCell: (params: GridCellParams) =>
        !params.row.is_signed_active ? (
          <Chip
            variant="outlined"
            color="warning"
            label={t("text_signed_inactive")}
            size="small"
          />
        ) : (
          <Chip
            variant="outlined"
            color="success"
            label={t("text_signed_active")}
            size="small"
          />
        ),
    },
    {
      field: "dmsFileId",
      headerName: `${t("text_file_dms")}`,
      width: 250,
      valueGetter: (params: GridCellParams) => params.row?.dmsFileId,
      renderCell: (params: GridCellParams) => {
        const fileId = params.row.dmsFileId
        const dataPath = params?.row?.file?.dataPath
        const fileName = params?.row?.file?.name || params?.row?.name
        let isMicrosoftFile
        if (fileName) {
          isMicrosoftFile = validateMicrosoftFile(fileName)
        }

        if (fileId && dataPath) {
          if (isMicrosoftFile) {
            return (
              <a href={dataPath} download={fileName}>
                {fileName}
              </a>
            )
          } else {
            return (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                onClick={() => debugBase64New(dataPath)}
                style={{ cursor: "pointer" }}
              >
                {fileName}
              </a>
            )
          }
        }
        return fileId || "-"
      },
    },
    {
      field: "employer",
      headerName: `${t("text_employee_name_employers")}`,
      width: 150,
      valueGetter: (params: GridCellParams) => params.row.employer,
      renderCell: (params: GridCellParams) => params.row.employer ?? "-",
    },
    {
      field: "created_date",
      headerName: `${t("Created date")}`,
      width: 150,
      valueGetter: (params: GridCellParams) =>
        Date.parse(params.row.exported_date),
      renderCell: (params: GridCellParams) =>
        typeof params.row.created_date === "string"
          ? dayjs(params.row.created_date).format("DD/MM/YYYY HH:mm")
          : "-",
    },
    {
      field: "created_by",
      headerName: `${t("Created By")}`,
      width: 150,
      valueGetter: (params: GridCellParams) => params.row.created_by,
      renderCell: (params: GridCellParams) => params.row.created_by ?? "-",
    },
  ]

  // NOTE: CustomToolbar — ซ้ำกันทุกหน้าที่มี DataGrid (37+ ไฟล์) ควรย้ายไปรวมใน components/common/DataGridToolbar.tsx
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    )
  }
  // working
  function changeStatus() {
    Swal.fire({
      title: `${t("Select action steps")}`,
      html:
        `<label class="changered-container" ><input id="pass" type="checkbox" name="check" /><span class="red">${
          localStorage.language === "th"
            ? statusData[7].show_on_hr
            : statusData[7].show_on_hr_en
        }</span></label>` +
        '<label class="changered-container" ><input type="checkbox" name="check" /></label>',
      showCancelButton: true,
      confirmButtonColor: "#43A047",
      cancelButtonText: `${t("Cancel")}`,
      confirmButtonText: `${t("Confirm")}`,
    }).then((result) => {
      if (result.isConfirmed) {
        const changeStatusFunction = async () => {
          try {
            const data = {
              id: appFormData?.id,
              status: false,
              statusId: 8,
            }
            const response = await uploadStatus(data)
            if (response.data?.success) {
              Swal.fire({
                icon: "success",
                title: `${t("Update status successful!")}`,
                confirmButtonColor: "#43A047",
                confirmButtonText: "OK!",
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then(() => {
                window.location.reload()
              })
            } else {
              Swal.fire({
                icon: "error",
                title: `${t("Update status failed!")}`,
                confirmButtonColor: "#43A047",
                confirmButtonText: "OK!",
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then(() => {
                changeStatus()
              })
            }
          } catch (error) {
            console.log(error)
            navigate("/servererror", { replace: true })
          }
        }
        changeStatusFunction()
      }
    })
  }

  return (
    <>
      <Box sx={{ height: "auto", maxWidth: "100%", mt: 2 }}>
        <Box display="flex" gap={3} sx={{ mb: 3 }}>
          <Box
            display="flex"
            component={ReactRouterLink}
            onClick={() => window.history.back()}
            sx={{
              textDecoration: "none",
              color: "#0d47a1",
              alignItems: "center",
              ":hover": {
                color: "#1976d2",
              },
            }}
          >
            <ChevronLeftIcon fontSize="small" />
            <Typography sx={{ fontWeight: "bold" }}>{t("Back")}</Typography>
          </Box>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="inherit"
              component={ReactRouterLink}
              to={`/jobs_status?content_type=${forwardPath}`}
            >
              <AssignmentTurnInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              {t("Job Application Status")}
            </Link>
            <Typography
              sx={{ display: "flex", alignItems: "center" }}
              color="text.primary"
            >
              <InfoIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              {t("JobAppDetail")}
            </Typography>
          </Breadcrumbs>
        </Box>
        <Box sx={{ mx: { xs: 1, sm: 15, mt: 2 }, my: { xs: 2, sm: 5, mt: 2 } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: 18, sm: 25 },
                  letterSpacing: 0.5,
                }}
              >
                {t("DataToEC")}
              </Typography>
            </Box>
            <Box>
              {" "}
              {/* No special display needed here if it's just one button */}
              <Button
                variant="contained"
                onClick={() => {
                  setUploadFilesStatus(true)
                }}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: { xs: "150px", sm: "none" },
                }}
              >
                {t("text_btn_upload_file_docs")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ mx: { xs: 1, sm: 10 }, my: { xs: 2, sm: 5 } }}>
        <Paper variant="outlined" sx={{ mb: 2 }}>
          <Grid container rowSpacing={1} paddingY={3} paddingX={5}>
            <Grid item xs={12} sm={12} display="flex" gap={4}>
              <Typography
                sx={{
                  fontSize: { xs: 15, sm: 17 },
                  mt: { xs: 1, sm: 2 },
                  letterSpacing: 0.5,
                }}
              >
                {t("Application date") + " "} {formatDate(1)} {t("time")}{" "}
                {dayjs(appFormData?.created_date).format("HH:mm")}
              </Typography>
            </Grid>

            {/* Personal Information */}
            <Grid container direction="column" gap={2}>
              <Grid item>
                <Grid item xs={12} sm={12} display="flex" mt={1}>
                  <Typography
                    fontWeight="bold"
                    sx={{
                      fontSize: { xs: 15, sm: 17 },
                      letterSpacing: 0.3,
                    }}
                  >
                    {t("Personal Information")}
                  </Typography>
                </Grid>
              </Grid>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={1}>
                  <Typography sx={bodyStyle}>{t("Full name TH")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {mapPrefix(appFormData?.prefix!, "TH")}{" "}
                    {appFormData?.first_name_th || "-"}{" "}
                    {appFormData?.last_name_th || "-"}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={1}>
                  <Typography sx={bodyStyle}>{t("Full name EN")} :</Typography>
                  {/* <Typography sx={bodyStyle}>{appFormData?.prefix} {appFormData?.first_name_en || '-'} {appFormData?.last_name_en || '-'}</Typography> */}
                  <Typography sx={bodyStyle}>
                    {" "}
                    {mapPrefix(appFormData?.prefix!, "EN")}{" "}
                    {appFormData?.first_name_en || "-"}{" "}
                    {appFormData?.last_name_en || "-"}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Gender")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {t(GENDER[appFormData?.gender!])}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Nationality")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {t(NATIONALITY[appFormData?.nationality!])}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Religion")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {t(RELIGION[appFormData?.religion!])}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("MaritalStatus")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {t(MARITAL_STATUS[appFormData?.marital_status!])}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Date of birth")} :</Typography>
                  <Typography sx={bodyStyle}>{formatDate(2)}</Typography>
                </Grid>
              </Box>
              <Box
                sx={{
                  display: { xs: "none", sm: "flex" },
                  flexDirection: { xs: "none", sm: "column" },
                  ml: { sm: 2 },
                }}
              >
                <Grid item sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>
                    {t("ID card number")} :
                  </Typography>
                  <Typography sx={bodyStyle}>
                    {appFormData?.national_id}
                  </Typography>
                </Grid>
              </Box>
            </Grid>

            {/* Contact Information */}
            <Grid container direction="column" gap={2}>
              <Grid item>
                <Typography
                  sx={{
                    fontSize: { xs: 15, sm: 17 },
                    fontWeight: "bold",
                    letterSpacing: 0.5,
                  }}
                >
                  {t("Contact Information")}
                </Typography>
              </Grid>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Phone Number")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {appFormData?.phone_number}
                  </Typography>
                </Grid>
              </Box>
            </Grid>

            {/* Address Information */}

            <Grid container direction="column" gap={2}>
              <Grid item>
                <Typography
                  sx={{
                    fontSize: { xs: 15, sm: 17 },
                    fontWeight: "bold",
                    letterSpacing: 0.5,
                  }}
                >
                  {t("Legal Address")}
                </Typography>
              </Grid>
              <Grid container direction="row" gap={1} sx={{ ml: { sm: 2 } }}>
                <Typography sx={bodyStyle}>
                  {t("House No.") + " "}{" "}
                  {appFormData?.legal_house_number
                    ? appFormData?.legal_house_number
                    : "-"}
                </Typography>
                <Typography sx={bodyStyle}>
                  {t("Moo") + " "}{" "}
                  {appFormData?.legal_moo ? appFormData?.legal_moo : "-"}
                </Typography>
                <Typography sx={bodyStyle}>
                  {t("Lane") + " "}{" "}
                  {appFormData?.legal_lane ? appFormData?.legal_lane : "-"}
                </Typography>
                {i18n.language === "th" ? (
                  <Typography sx={bodyStyle}>
                    {"ถนน"}{" "}
                    {appFormData?.legal_street
                      ? appFormData?.legal_street
                      : "-"}
                  </Typography>
                ) : (
                  <Typography sx={bodyStyle}>
                    {appFormData?.legal_street
                      ? appFormData?.legal_street
                      : "-"}{" "}
                    Street,
                  </Typography>
                )}
              </Grid>
              <Grid container direction="row" gap={1} sx={{ ml: { sm: 2 } }}>
                {i18n.language === "th" ? (
                  <>
                    <Typography sx={bodyStyle}>
                      {t("Sub District")}{" "}
                      {appFormData?.legal_sub_district
                        ? appFormData?.legal_sub_district
                        : "-"}
                    </Typography>
                    <Typography sx={bodyStyle}>
                      {t("District")}{" "}
                      {appFormData?.legal_district
                        ? appFormData?.legal_district
                        : "-"}
                    </Typography>
                    <Typography sx={bodyStyle}>
                      {t("Province")}{" "}
                      {appFormData?.legal_province
                        ? appFormData?.legal_province
                        : "-"}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography sx={bodyStyle}>
                      {subDistrictsEN[0]} {"Sub-District"},
                    </Typography>
                    <Typography sx={bodyStyle}>
                      {districtsEN[0]} {t("District")},
                    </Typography>
                    <Typography sx={bodyStyle}>{provincesEN[0]},</Typography>
                  </>
                )}
                <Typography sx={bodyStyle}>
                  {appFormData?.legal_postal_code}
                </Typography>
              </Grid>
            </Grid>
            {appFormData?.same_as_legal === "No" ? (
              <Grid container direction="column" gap={2}>
                <Grid item>
                  <Typography
                    sx={{
                      fontSize: { xs: 15, sm: 17 },
                      fontWeight: "bold",
                      letterSpacing: 0.5,
                    }}
                  >
                    {t("Mailing Address")}
                  </Typography>
                </Grid>
                <Grid container direction="row" gap={1} sx={{ ml: { sm: 2 } }}>
                  <Typography sx={bodyStyle}>
                    {t("House No.") + " "}{" "}
                    {appFormData?.mailing_house_number
                      ? appFormData?.mailing_house_number
                      : "-"}
                  </Typography>
                  <Typography sx={bodyStyle}>
                    {t("Moo") + " "}{" "}
                    {appFormData?.mailing_moo ? appFormData?.mailing_moo : "-"}
                  </Typography>
                  <Typography sx={bodyStyle}>
                    {t("Lane") + " "}{" "}
                    {appFormData?.mailing_lane
                      ? appFormData?.mailing_lane
                      : "-"}
                  </Typography>
                  {i18n.language === "th" ? (
                    <Typography sx={bodyStyle}>
                      {"ถนน"}{" "}
                      {appFormData?.mailing_street
                        ? appFormData?.mailing_street
                        : "-"}
                    </Typography>
                  ) : (
                    <Typography sx={bodyStyle}>
                      {appFormData?.mailing_street
                        ? appFormData?.mailing_street
                        : "-"}{" "}
                      Street,
                    </Typography>
                  )}
                </Grid>
                <Grid container direction="row" gap={1} sx={{ ml: { sm: 2 } }}>
                  <>
                    <Typography sx={bodyStyle}>
                      {t("Sub District")}{" "}
                      {appFormData?.mailing_sub_district
                        ? appFormData?.mailing_sub_district
                        : "-"}
                    </Typography>
                    <Typography sx={bodyStyle}>
                      {t("District")}{" "}
                      {appFormData?.mailing_district
                        ? appFormData?.mailing_district
                        : "-"}
                    </Typography>
                    <Typography sx={bodyStyle}>
                      {t("Province")}{" "}
                      {appFormData?.mailing_province
                        ? appFormData?.mailing_province
                        : "-"}
                    </Typography>
                  </>

                  <Typography sx={bodyStyle}>
                    {appFormData?.mailing_postal_code}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Typography
                sx={{
                  fontSize: { xs: 15, sm: 17 },
                  ml: { sm: 2 },
                  letterSpacing: 0.3,
                }}
              >
                {t("Same as legal address")}
              </Typography>
            )}

            <Grid container direction="column" gap={2}>
              <Grid item>
                <Typography
                  sx={{
                    fontSize: { xs: 15, sm: 17 },
                    fontWeight: "bold",
                    letterSpacing: 0.5,
                  }}
                >
                  {t("Job Information")}
                </Typography>
              </Grid>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Workplace")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {appFormData?.site_id ? appFormData?.site_id : "-"}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{ ml: { sm: 2 } }}
              >
                <Grid item xs={12} sm={12} display="flex" gap={2}>
                  <Typography sx={bodyStyle}>{t("Company")} :</Typography>
                  <Typography sx={bodyStyle}>
                    {appFormData?.company ? appFormData?.company : "-"}
                  </Typography>
                </Grid>
              </Box>
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                gap={{ xs: 0, sm: 1 }}
                sx={{ ml: { sm: 2 } }}
              >
                {/* Label */}
                <Typography sx={bodyStyle}>
                  {t("job_relationship_email")} :
                </Typography>

                {/* Value */}
                <Typography sx={bodyStyle}>
                  {appFormData?.job_relationship_email
                    ? appFormData?.job_relationship_email
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid container direction="column" gap={2}>
              <Grid container direction="row">
                <Typography
                  sx={{
                    fontSize: { xs: 15, sm: 17 },
                    fontWeight: "bold",
                    letterSpacing: 0.5,
                  }}
                >
                  {t("file attached") + " : "}
                </Typography>
              </Grid>
              <Grid item sx={{ ml: 2 }}>
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={1}
                  sx={{ ml: 3, mt: 1.5 }}
                >
                  {filesBaseData?.length > 0 ? (
                    filesBaseData.map((item: any, index) => {
                      const isMicrosoftFile = validateMicrosoftFile(item.name)

                      return (
                        <div key={index}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            display="flex"
                            sx={{
                              flexDirection: { xs: "column", sm: "row" },
                              gap: { xs: 0, sm: 2 },
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: { xs: 15, sm: 17 },
                                letterSpacing: 0.3,
                              }}
                            ></Typography>
                            <Typography
                              sx={{
                                fontSize: { xs: 15, sm: 17 },
                                letterSpacing: 0.3,
                              }}
                            >
                              {isMicrosoftFile ? (
                                <a href={item.dataPath} download={item.name}>
                                  {item.name}
                                </a>
                              ) : (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a
                                  onClick={() => {
                                    debugBase64(item.dataPath)
                                  }}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {item.name}
                                </a>
                              )}
                            </Typography>
                          </Grid>
                        </div>
                      )
                    })
                  ) : documentsRefs?.length < 1 ? (
                    <div>{t("text_documents_refs")} </div>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      display="flex"
                      sx={{
                        flexDirection: { xs: "column", sm: "row" },
                        gap: { xs: 0, sm: 2 },
                      }}
                    >
                      <CircularProgress size={20} sx={{ mr: 2 }} />
                    </Grid>
                  )}
                </Box>
              </Grid>
            </Grid>
            {/* working */}
            {type === "excels-ec" && (
              <Grid>
                <Box display="flex" sx={{ alignItems: "center", gap: 4 }}>
                  <Box display="flex" gap={2} sx={{ alignItems: "center" }}>
                    <Typography fontWeight="bold">{t("Status")}</Typography>
                    <Chip
                      variant="outlined"
                      sx={{
                        bgcolor: statusForm?.color ?? "#49af4d",
                        borderColor: statusForm?.color ?? "#49af4d",
                        color: "white",
                        my: 1.5,
                      }}
                      size="medium"
                      label={
                        localStorage.language === "th"
                          ? statusForm?.show_on_hr
                          : statusForm?.show_on_hr_en
                      }
                    />
                  </Box>
                  {statusForm?.id !== 8 && (
                    <div>
                      {
                        <Tooltip
                          title={t("Edit Status")}
                          onClick={changeStatus}
                        >
                          <Box display="flex" gap={1}>
                            <Icon
                              fontSize="medium"
                              color="secondary"
                              sx={{
                                ":hover": {
                                  cursor: "pointer",
                                },
                              }}
                            >
                              {/* change */}
                              edit
                            </Icon>
                            <Typography
                              sx={{
                                fontSize: { xs: 14, sm: 16 },
                                color: "blue",
                                ":hover": { cursor: "pointer" },
                              }}
                            >
                              {t("Edit Status")}
                            </Typography>
                          </Box>
                        </Tooltip>
                      }
                    </div>
                  )}
                </Box>
              </Grid>
            )}
          </Grid>
          <Grid container rowSpacing={1} paddingY={3} paddingX={5}>
            {loadingUpload ? (
              <Box display="flex" justifyContent="center" gap={2}>
                <CircularProgress size={100} />
              </Box>
            ) : contractList.length === 0 ? (
              <Typography align="center">
                {t("No data")} {t("text_contract_file_name")}
              </Typography>
            ) : (
              <>
                <Box display="inline-grid" sx={{ width: "100%" }}>
                  <DataGrid
                    getRowId={(row) => row.id}
                    rows={contractList}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    pagination
                    pageSizeOptions={[10, 20, 30, 40, 50]}
                    getRowHeight={() => 50}
                    disableRowSelectionOnClick
                    sx={{
                      "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
                        {
                          outline: "none !important",
                        },
                      fontSize: 13,
                    }}
                    slots={{
                      toolbar: CustomToolbar,
                    }}
                    slotProps={{
                      filterPanel: {
                        filterFormProps: {
                          logicOperatorInputProps: {
                            variant: "outlined",
                            size: "small",
                          },
                          columnInputProps: {
                            variant: "outlined",
                            size: "small",
                            sx: { mt: "auto" },
                          },
                          operatorInputProps: {
                            variant: "outlined",
                            size: "small",
                            sx: { mt: "auto" },
                          },
                          valueInputProps: {
                            InputComponentProps: {
                              variant: "outlined",
                              size: "small",
                            },
                          },
                          deleteIconProps: {
                            sx: {
                              "& .MuiSvgIcon-root": { color: "#d32f2f" },
                            },
                          },
                        },
                        sx: {
                          "& .MuiDataGrid-filterForm": { p: 2 },
                          "& .MuiDataGrid-filterForm:nth-of-type(even)": {
                            backgroundColor: () =>
                              theme.palette.mode === "dark"
                                ? "#444"
                                : "#f5f5f5",
                          },
                          "& .MuiDataGrid-filterFormLogicOperatorInput": {
                            mr: 2,
                          },
                          "& .MuiDataGrid-filterFormColumnInput": {
                            mr: 2,
                            width: 150,
                          },
                          "& .MuiDataGrid-filterFormOperatorInput": {
                            mr: 2,
                          },
                          "& .MuiDataGrid-filterFormValueInput": {
                            width: 200,
                          },
                        },
                      },
                    }}
                    localeText={
                      i18n.language === "en"
                        ? enUS.components.MuiDataGrid.defaultProps.localeText
                        : thTHGrid
                    }
                    // unstable_headerFilters
                  />
                </Box>
              </>
            )}
          </Grid>
        </Paper>
      </Box>
      <div>
        <UploadFileDocs
          keepMounted
          onClose={() => {
            setUploadFilesStatus(false)
          }}
          userId={userId}
          open={uploadFilesStatus}
        />
      </div>
    </>
  )
}

export default ExcelEcDetail
